import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import InputText from '../../formElements/InputText';
import sAction from 'sAction';
import Button from '../../formElements/Button';
import assembleURLHash from '../../../action/Base/route/assembleURLHash';

export default function DuplicateUntilPopup(props) {
    const module = props.data.get('params').get('module');
    const recordId = props.data.get('params').get('id');

    const [createdInvoices, setCreatedInvoices] = useState([]);
    const [startYear, setStartYear] = useState(String(new Date().getFullYear()));
    const [untilYear, setUntilYear] = useState(startYear);

    const changeHandler = (event) => {
        switch (event.target.name) {
            case 'startYear':
                setStartYear(event.target.value);
                break;
            case 'untilYear':
                setUntilYear(event.target.value);
                break;
        }
    };

    const clickHandler = () => {
        sAction.load();
        sAction.rest.fetchData('duplicateUntil', 'POST', {module, recordId, startYear, untilYear}).then((returnData) => {
            const newInvoices = createdInvoices;
            returnData.data.forEach((inv) => {
                newInvoices.push(<a key={inv.year} href={assembleURLHash('detail', module, inv.id)}>{inv.year}</a>);
            });
            setCreatedInvoices(newInvoices);
            sAction.unLoad();
        }).catch((errorData) => {
            sAction.error(errorData.text);
            sAction.unLoad();
        });
    };

    return (
        <React.Fragment>
            <div className='acmPopupContent duplicateUntilPopupContent'>
                {sAction.translate('LBL_DUPLICATE_UNTIL_DESCRIPTION', module)}
                <div className='duplicateUntilPopupInput'>
                    <InputText
                        margin="dense"
                        label={sAction.translate('LBL_DUPLICATE_UNTIL_START_YEAR', module)}
                        type="text"
                        name="startYear"
                        value={startYear}
                        onChange={changeHandler}
                    />
                    <InputText
                        margin="dense"
                        label={sAction.translate('LBL_DUPLICATE_UNTIL_UNTIL_YEAR', module)}
                        type="text"
                        name="untilYear"
                        value={untilYear}
                        onChange={changeHandler}
                    />
                </div>
            </div>
            <div className='acmPopupButtons'>
                <Button className="hoverBlue" onClick={clickHandler}>
                    <div className="icon-duplicateIcon" />
                    {sAction.translate('LBL_DUPLICATE_UNTIL_PROCEED', module)}
                </Button>
                <Button className="hoverBlue" onClick={() => sAction.popupHide()}>
                    <div className="icon-undo" />
                    {sAction.translate('LBL_CANCEL', module)}
                </Button>
            </div>
            <div className='duplicateUntilPopupFooter'>
                {createdInvoices}
            </div>
        </React.Fragment>
    );
}

DuplicateUntilPopup.propTypes = {
    data: ImmutablePropTypes.mapContains({
        params: ImmutablePropTypes.mapContains({
            module: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};
